export default __webpack_public_path__ + "static/media/tShirt.67a653b3.jpeg";